import logo from './logo.svg';
import { HashRouter as Router, Route, Routes } from "react-router-dom";


import Home from './Home';
import About from './About';
import Fixtures from './Fixtures';
import ErrorPage from './ErrorPage';
import NavBar from './NavBar';
import ManicMiner from './ManicMiner';
import SpaceInvaders from './SpaceInvaders';
import TempestSocialMedia from './TempestSocialMedia';
import Contact from './Contact';
import Services from './Services';
import Games from './Games';
import PixelConverter from './PixelConverter';
import ThemBones from './ThemBones';
import { motion } from 'framer-motion';
import './css/App.css';

function App() {

  return (
    <Router>
    <NavBar />
    <div className={"theMainDiv"}>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/fixtures" element={<Fixtures />} />
        <Route path="/manicminer" element={<ManicMiner />} />
        <Route path="/spaceinvaders" element={<SpaceInvaders />} />
        <Route path="/games" element={<Games />} />
        <Route path="/pixel-converter" element={<PixelConverter />} />
        <Route path="/thembones" element={<ThemBones />} />
        <Route path="/tempest" element={<TempestSocialMedia />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      </div>
  </Router>
    
  );
}

export default App;
